export const LOGIN_DIALOG_OPEN = 'LOGIN_DIALOG_OPEN'
export const LOGIN_DIALOG_CLOSE = 'LOGIN_DIALOG_CLOSE'
export const REMOTE_DIALOG_CLOSE = 'REMOTE_DIALOG_CLOSE'
export const REMOTE_DIALOG_OPEN = 'REMOTE_DIALOG_OPEN'



// WEBPACK FOOTER //
// ./src/types/actions/login-dialog.js